import React, { FunctionComponent } from 'react';
import safariBrowserSettings from 'assets/images/help/safari-browser-settings.png';
import ImageMagnifier from 'components/imageMagnifier/ImageMagnifier';
import HelpStyles from '../../Help.module.scss';

const SafariDesktop: FunctionComponent = () => {
  return (
    <div className={HelpStyles.sharedHelpStyles}>
      <div className={HelpStyles.steps}>
        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>1</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Open Safari browser
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>2</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Click <strong>Safari</strong> from the menu bar → <strong>Settings</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>3</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Click the <strong>Websites</strong> tab
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>4</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Select <strong>Location</strong> from the left sidebar
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>5</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Expand <strong>"When visiting other websites"</strong> dropdown
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>6</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Choose <strong>Allow</strong> (recommended) or <strong>Deny</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>7</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              For specific sites, select the site and choose <strong>Allow</strong>, <strong>Deny</strong>, or <strong>Ask</strong>
            </p>
          </div>
        </div>
      </div>

      <ImageMagnifier 
        src={safariBrowserSettings} 
        alt="Safari browser settings showing location permissions" 
        caption="Safari Settings → Websites → Location"
        className={HelpStyles.screenshot}
      />

      <div className={HelpStyles.tip}>
        <div className={HelpStyles.tipIcon}>💡</div>
        <div className={HelpStyles.tipContent}>
          <p className="fontFourteen poppins-regular text-gray">
            <strong>Tip:</strong> The screenshot shows where to find location settings in Safari.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SafariDesktop;